// Libraries
import { List } from '@chakra-ui/react';
import { useCallback } from 'react';
// Components
import { Voyage, VoyageCard } from '@molecules/index';
import { VoyageListItem } from './Components';
// Types
import { VoyageInnerListProps } from './VoyageInnerList.type';

/**
 * VoyageInnerList component.
 *
 * @component
 * @param {VoyageInnerListProps} props - The props for the VoyageInnerList component.
 * @param {Voyage[]} props.voyages - The array of voyages to be rendered.
 * @param {LayoutProps.h} [props.height='auto'] - The height of the VoyageInnerList component as a string.
 * @param {Function} props.handleClick - The click event handler for selecting a voyage.
 * @param {string} props.selectedVoyageId - The ID of the currently selected voyage.
 * @param {Function} props.checkVoyageIsActive - Check if the voyage is active, usually the most recent one.
 * @returns {ReactElement} The rendered VoyageInnerList component.
 */
export const VoyageInnerList = (props: VoyageInnerListProps) => {
  const { voyages, handleClick, selectedVoyageId, checkVoyageIsActive } = props;

  const onClick = useCallback((voyage: Voyage) => () => handleClick(voyage), [handleClick]);

  return (
    <List>
      {voyages.map((voyage) => (
        <VoyageListItem
          key={voyage.voyageId}
          isSelected={selectedVoyageId == voyage.voyageId}
          handleClick={onClick(voyage)}
        >
          <VoyageCard voyage={voyage} isActive={checkVoyageIsActive(voyage)} />
        </VoyageListItem>
      ))}
    </List>
  );
};
